import { CopyToClipboard, Icon, TextEllipsis } from '@aibees/shared/components';
import { classnames, urlToValidHttps } from '@aibees/shared/utils';
import { Badge, Box, Divider, Link, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentCompanyContactDataPopoverProps as Props } from './types';

const ANCHOR_ORIGIN = {
  horizontal: 'left' as const,
  vertical: 'bottom' as const,
};
const TRANSFORM_ORIGIN = {
  horizontal: 'left' as const,
  vertical: 'top' as const,
};

export const CurrentCompanyContactDataPopover = memo(
  ({ className, type, state, title, icon, copyValue, value }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CurrentCompanyContactDataPopover', className)}
        state={state}
        sx={SX.customPopover}
        contentSx={SX.content}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <Stack sx={SX.column}>
          {title && (
            <>
              <Typography
                variant="body4"
                fontWeight={700}
                color="grey.800"
                p={0.5}
              >
                {title}
              </Typography>
              <Divider />
            </>
          )}
          {type === 'network' ? (
            <Stack sx={SX.network}>
              {Array.isArray(value) &&
                value.map((item) => (
                  <Link
                    key={item}
                    href={urlToValidHttps(item)}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={SX.link}
                  >
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Box>
                        <Icon name={icon} size={16} color="grey.500" />
                      </Box>
                      <TextEllipsis variant="body4" color="grey.700">
                        {item}
                      </TextEllipsis>
                      <Box>
                        <Icon name="open-in-new" size={16} color="grey.500" />
                      </Box>
                    </Stack>
                  </Link>
                ))}
            </Stack>
          ) : (
            <Stack sx={SX.row}>
              <Stack sx={SX.titleWrapper}>
                <Badge
                  size={16}
                  color="success"
                  badgeContent="A+"
                  variant="soft"
                >
                  <Icon name={icon} size={16} color="grey.500" />
                </Badge>

                {type === 'email' ? (
                  <TextEllipsis
                    value={Array.isArray(value) ? value[0] : value}
                    variant="body4"
                    w="85px"
                    color="grey.600"
                  />
                ) : (
                  <Typography variant="body4" color="grey.600">
                    {value}
                  </Typography>
                )}
              </Stack>

              <CopyToClipboard
                sx={{ display: 'flex' }}
                icon={<Icon name="copy-outline" size={16} sxx={SX.copyIcon} />}
                value={copyValue}
              />
            </Stack>
          )}
        </Stack>
      </Styled.Wrapper>
    );
  }
);

CurrentCompanyContactDataPopover.displayName =
  'CurrentCompanyContactDataPopover';
